module.exports = __webpack_public_path__ + "img/Contacto.7ac78550.png";